import { useEffect } from 'react';

// React 19 hoists <title>, <meta> e <link> automaticamente para o <head>.
// Para JSON-LD usamos useEffect (scripts inline não são hoisted nativamente).

const SITE_URL = 'https://bestcars.com.pt';
const SITE_NAME = 'BestCars';
const DEFAULT_DESCRIPTION = 'Stand premium em Castanheira do Ribatejo. Viaturas selecionadas com garantia, financiamento e atendimento personalizado. Mais de 15 anos de experiência.';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

const JsonLd = ({ data }) => {
  const items = Array.isArray(data) ? data : [data];
  const key = JSON.stringify(items);

  useEffect(() => {
    const scripts = items.map(item => {
      const el = document.createElement('script');
      el.type = 'application/ld+json';
      el.setAttribute('data-seo', 'true');
      el.textContent = JSON.stringify(item);
      document.head.appendChild(el);
      return el;
    });
    return () => scripts.forEach(el => el.parentNode?.removeChild(el));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return null;
};

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  canonical,
  ogImage,
  ogType = 'website',
  noindex = false,
  jsonLd,
}) => {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : 'BestCars — Comércio de Automóveis | Stand Premium em Castanheira do Ribatejo';
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : null;
  const image = ogImage || DEFAULT_OG_IMAGE;
  const robots = noindex
    ? 'noindex, nofollow'
    : 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1';

  return (
    <>
      {/* React 19 hoist nativo para <head> */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="pt_PT" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Structured Data */}
      {jsonLd && <JsonLd data={jsonLd} />}
    </>
  );
};

export { SITE_URL, SITE_NAME };
export default SEO;
